import { ComponentPortal } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, computed, TemplateRef, viewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { M040C140Tabs, M040C140TabsComponent } from '@hyundai/ui';
import { VehicleCommentsTabComponent } from './tabs/vehicle-comments-tab.component';
import { VehicleDataTabComponent } from './tabs/vehicle-data-tab.component';
import { VehicleEquipmentTabComponent } from './tabs/vehicle-equipment-tab.component';

const TABS = {
    VehicleData: 'vehicleData',
    Equipment: 'equipment',
    Comments: 'comments',
};

@Component({
    selector: 'lib-vehicle-detail-infos',
    standalone: true,
    imports: [M040C140TabsComponent, VehicleDataTabComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    template: `
        <section class="inner-page-wrapper py-16 lg:py-56">
            <ui-m040-c140-tabs [options]="tabOptions()" [control]="tabsControl" small />
        </section>
    `,
})
export class VehicleDetailInfosComponent {
    tabsControl = new FormControl(TABS.VehicleData, { nonNullable: true });
    commentsTemplate = viewChild.required(TABS.Comments, { read: TemplateRef });

    tabOptions = computed<M040C140Tabs[]>(() => {
        return [
            {
                portal: new ComponentPortal(VehicleDataTabComponent),
                label: 'Fahrzeugdaten',
                value: TABS.VehicleData,
                visible: true,
            },
            {
                portal: new ComponentPortal(VehicleEquipmentTabComponent),
                label: 'Ausstattung',
                value: TABS.Equipment,
                visible: true,
            },
            {
                portal: new ComponentPortal(VehicleCommentsTabComponent),
                label: 'Beschreibung',
                value: TABS.Comments,
                visible: true,
            },
        ];
    });
}
